var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.person.emails.email') + ' *',
      "rules": _vm.emailRule,
      "outlined": ""
    },
    model: {
      value: _vm.value.email,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "email", $$v);
      },
      expression: "value.email"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "items": Object.values(_vm.PersonLabelEnum),
      "label": _vm.$t('objects.person.emails.label'),
      "auto-select-first": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.PersonLabelEnum.".concat(item))) + " ")];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.PersonLabelEnum.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.label,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "label", $$v);
      },
      expression: "value.label"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.person.emails.notes'),
      "auto-select-first": "",
      "outlined": "",
      "multiple": ""
    },
    model: {
      value: _vm.value.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "notes", $$v);
      },
      expression: "value.notes"
    }
  }), _c('debug', [_vm._v(" " + _vm._s(_vm.value) + " ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }